const Cmtpax = (state) => state.Cmtpax
const CheckServices = (state) => state.CheckServices
const PaxsGroup = (state) => state.PaxsGroup
const Services = (state) => state.Services
const monetaryService = (state) => state.monetaryService
const OverNightStation = (state) => state.OverNightStation

export default {
  Cmtpax,
  CheckServices,
  PaxsGroup,
  Services,
  monetaryService,
  OverNightStation
}
